import { render, staticRenderFns } from "./factoryInfo.vue?vue&type=template&id=dd483b6a&scoped=true"
import script from "./factoryInfo.vue?vue&type=script&lang=js"
export * from "./factoryInfo.vue?vue&type=script&lang=js"
import style0 from "./factoryInfo.vue?vue&type=style&index=0&id=dd483b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd483b6a",
  null
  
)

export default component.exports